(function () {
	function initSliders() {
		if (typeof Swiper === 'undefined') return;
		if (typeof subSliderInit === 'function') {
			subSliderInit(true, 16);
		}
		if (typeof sliderInit === 'function') {
			sliderInit(true);
		}
		if (typeof popupSliderInit === 'function') {
			popupSliderInit(true);
		}
	}

	function scheduleInit() {
		if (window.requestAnimationFrame) {
			window.requestAnimationFrame(initSliders);
		} else {
			setTimeout(initSliders, 0);
		}
	}

	document.addEventListener('shopify:section:load', function () {
		setTimeout(scheduleInit, 100);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
	} else {
		scheduleInit();
	}
})();
